<template>
  <BTooltip
    top
    :content="tooltipMessage"
  >
    <BBtn
      v-bind="$attrs"
      type="primary"
      size="mini"
      fab
      :disabled="disabled"
      @click="$emit('click')"
    >
      <BIcon
        size="small"
        type="white"
      >
        phone_in_talk
      </BIcon>
    </BBtn>
  </BTooltip>
</template>

<script lang="ts" setup>
defineProps<{
  tooltipMessage?: string;
  disabled: boolean;
}>();
defineEmits<{
  'click': [];
}>();

defineOptions({
  inheritAttrs: false,
});
</script>
